import { useQuery } from '@tanstack/react-query';
import getPaymentOptions from '../../api/payment/get-payment-options';
import { paymentKeys } from './query-keys';

// Not a staleness-tolerance decision: this only dedupes the burst of sibling components
// (CartInfo, payment method buttons, PaypalExpress, ...) that each call this hook and mount
// within the same checkout render pass. Payment options don't change mid-checkout, so a short
// stale window covers that without masking a genuinely stale page (e.g. left open for a while).
const STALE_TIME = 30_000;
const GC_TIME = 5 * 60_000;

const usePaymentOptions = (currencyCode: string) =>
    useQuery({
        queryKey: paymentKeys.options(currencyCode),
        queryFn: () => getPaymentOptions({ currencyCode }),
        enabled: Boolean(currencyCode),
        staleTime: STALE_TIME,
        gcTime: GC_TIME,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false
    });

export default usePaymentOptions;
